import React from 'react';
import classes from './GamesComponent.module.scss';

function GamesComponent({
  backGroundImage,
  LogoIcon,
  logoPlace,
  overLay,
  gameName,
  onClick
}) {
  return (
    <>
      {gameName && <span className={classes.titleGames}>{gameName}</span>}

      <div className={`${classes.gameComponent} ${classes[backGroundImage]}`}>
        <div
          className={`${classes.logoInside} ${classes[backGroundImage]} ${logoPlace ? classes.logoLeft : ''}`}
        >
          {LogoIcon && (
            <img
              src={LogoIcon}
              alt="logo Icon"
              className={`${classes.logoStyle} ${classes[backGroundImage]}`}
            />
          )}
        </div>
        <div className={`${classes.overlay} ${classes[overLay]}`}>
          <button className={`${classes.btn} ${classes[overLay]}`} onClick={onClick ? onClick : undefined}>
            {overLay === 'white' ? 'Play' : 'TRY OUT'}
          </button>
        </div>
      </div>
    </>
  );
}

export default GamesComponent;
